// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FormSection_wrap__2RtCK"};